module.exports = __webpack_public_path__ + "img/bit_recharge_icon.2a9339d6.svg";